<template>
  <content-layout>
    <template #header>Tags/Attributes</template>
    <template #description>The tags staff tick on a location and its images. The number shows how many locations
      use each tag; a tag can only be deleted when nothing uses it.</template>

    <el-tabs v-model="activeTab">
      <el-tab-pane v-for="(page, index) in this.pages" :label=page.name :name="page.name" :key="page.name">
        <div class="tag-cloud">
          <span v-for="tag in page.tags" :key="tag.id" class="attribute-tag">
            <span class="attribute-tag__name">{{ tag.name }}</span>
            <span class="attribute-tag__usage" :title="tag.usage + ' locations use this tag'">{{ tag.usage }}</span>
            <el-button class="attribute-tag__button" type="text" icon="el-icon-edit" title="Rename"
                       @click="toggleDialogBox(tag.id, tag.name)"></el-button>
            <el-button class="attribute-tag__button attribute-tag__button--delete" type="text" icon="el-icon-close" title="Delete"
                       @click="handleClose(tag, index)"></el-button>
          </span>

          <el-input
            class="input-new-tag"
            v-if="inputVisible === page.name"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            placeholder="Tag name"
            @keyup.enter.native="handleInputConfirm(index)"
            @blur="handleInputConfirm(index)"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" icon="el-icon-plus" @click="showInput(page.name)">New Tag</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
            title="Rename tag"
            :visible.sync="editDialogVisible"
            width="420px">
      <el-form ref="form" label-position="top" @submit.native.prevent="patchAttribute">
        <el-form-item label="Current name">
          <span>{{editAttributeOldValue}}</span>
        </el-form-item>
        <el-form-item label="New name">
          <el-input v-model="editAttributeNewValue"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toggleDialogBox()">Cancel</el-button>
        <el-button type="primary" @click="patchAttribute">Save</el-button>
      </span>
    </el-dialog>
  </content-layout>
</template>

<script>
  export default {
    data() {
      return {

        editDialogVisible: false,
        editAttributeId: '',
        editAttributeOldValue: '',
        editAttributeNewValue: '',

        pages: [
          {name: 'Building Type', tags: []},
          {name: 'Exterior Style', tags: []},
          {name: 'Interior Style', tags: []},
          {name: 'Outside Spaces', tags: []},
          {name: 'Suitable For', tags: []},
          {name: 'Image Tags', tags: []}

        ],
        // The tab whose "New Tag" box is open, if any.
        inputVisible: false,
        activeTab: 'Building Type',
        inputValue: '',

        attributes: []
      }
    },
    methods: {

      toggleDialogBox(id = false, oldValue) {
        if(id) {
          this.editAttributeId = id;
          this.editAttributeOldValue = oldValue;
          this.editDialogVisible = true;
        } else {
          this.editAttributeId = '';
          this.editAttributeOldValue = '';
          this.editAttributeNewValue = '';
          this.editDialogVisible = false;
        }
      },

      patchAttribute() {
        this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/attributes/${this.editAttributeId}`, { title: this.editAttributeNewValue },
                {headers: {Authorization: localStorage.getItem('Authorization')}})
                .then(response => {
                  this.toggleDialogBox();
                  this.$notify({
                    title: 'Success',
                    message: 'Attribute Edited.',
                    type: 'success'
                  });
                  this.loadAttributes();
                })
                .catch(err => {
                  this.$notify.error({
                    title: 'Error',
                    message: err
                  });
                });
      },

      handleClose(tag, index) {

        // If no location is using tag, delete (after checking)
        if (this.pages[index].tags[this.pages[index].tags.indexOf(tag)].usage == 0) {

          this.$confirm(`Delete the "${tag.name}" tag?`, 'Delete tag', {
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => this.axios.delete(`${process.env.VUE_APP_ROOT_API}/api/attributes/${this.pages[index].tags[this.pages[index].tags.indexOf(tag)].id}`,
            {headers: {Authorization: localStorage.getItem('Authorization')}})
            .then(result => {
              console.log(result);
              this.pages[index].tags.splice(this.pages[index].tags.indexOf(tag), 1);

              this.$notify({
                title: 'Success',
                message: 'Attribute Deleted.',
                type: 'success'
              });
            }))
            .catch(err => {
              console.log(err);
            });


          // Else alert
        } else {
          this.$alert(`There are still ${this.pages[index].tags[this.pages[index].tags.indexOf(tag)].usage} locations using this tag.`, 'Tag Cannot Be Deleted', {
            confirmButtonText: 'OK'
          });
        }

      },

      showInput(pageName) {
        this.inputVisible = pageName;
        this.$nextTick(_ => {
          // The ref is inside a v-for, so it's a list (with one entry, the open box).
          const input = [].concat(this.$refs.saveTagInput).find(Boolean);
          if (input) input.$refs.input.focus();
        });
      },

      handleInputConfirm(index) {
        let inputValue = this.inputValue;
        if (inputValue) {
          // this.dynamicTags.push(inputValue);

          // API Create
          this.axios.post(`${process.env.VUE_APP_ROOT_API}/api/attributes`,
            {
              title: inputValue,
              type: this.pages[index].name
            },
            {
              headers: {
                Authorization: localStorage.getItem('Authorization')
              }
            })
            .then(result => {
              // Acquire the id of the created attribute and add it to the list of tags.
              this.pages[index].tags.push({id: result.data.created._id, name: inputValue, usage: 0});

              this.$notify({
                title: 'Success',
                message: 'Attribute Added.',
                type: 'success'
              });
            })
            .catch(err => {
              console.log(err);
            });

        }

        this.inputVisible = false;
        this.inputValue = '';
      },


      loadAttributes() {
        this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/attributes/withUsage`, {headers: {Authorization: localStorage.getItem('Authorization')}})
                .then(response => {
                  this.attributes = response.data;
                  // Puts them in order of how many uses they have.
                  // this.attributes.sort(function (a, b) {
                  //   if (a.usage < b.usage) {
                  //     return 0;
                  //   } else {
                  //     return -1;
                  //   }
                  // });

                  // Order by alphabetical
                  this.attributes.sort((a,b) => {
                    if(a.title.toUpperCase() > b.title.toUpperCase()) {
                      return 0;
                    } else {
                      return -1;
                    }
                  });

                  this.pages =  [
                    {name: 'Building Type', tags: []},
                    {name: 'Exterior Style', tags: []},
                    {name: 'Interior Style', tags: []},
                    {name: 'Outside Spaces', tags: []},
                    {name: 'Suitable For', tags: []},
                    {name: 'Image Tags', tags: []}

                  ];
                  //  Loop through attributes and add to pages.
                  this.attributes.forEach((item1, index1) => {
                    this.pages.forEach((item2, index2) => {
                      if (item1.type == item2.name) {
                        item2.tags.push({id: item1._id, name: item1.title, usage: item1.usage});
                      }
                    });
                  });
                })
                .catch(error => {
                  console.log(error);
                });
      }


    },

    // Load all attributes before mounting DOM.
    beforeMount() {
      this.loadAttributes();
    }

  }
</script>

<style scoped>
  .tag-cloud {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .attribute-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 6px 0 12px;
    border: 1px solid var(--border);
    border-radius: 16px;
    background: #fff;
    font-size: 13px;
  }

  .attribute-tag:hover {
    border-color: var(--lav-green);
  }

  .attribute-tag__usage {
    min-width: 18px;
    padding: 0 6px;
    border-radius: 9px;
    background: var(--lav-green-soft);
    color: var(--lav-green-dark);
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
  }

  .attribute-tag__button {
    padding: 4px;
    color: var(--text-muted);
  }

  .attribute-tag__button + .attribute-tag__button {
    margin-left: 0;
  }

  .attribute-tag__button:hover {
    color: var(--lav-green-dark);
  }

  .attribute-tag__button--delete:hover {
    color: #F56C6C;
  }

  .input-new-tag {
    width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/Attributes.vue